var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"width":"50%","alt":"Cartoon logo","src":require("./assets/dividing-amoeba.jpg")}}),_c('Form'),(_vm.$store.state.history.length)?_c('History'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }